module.exports = __webpack_public_path__ + "static/media/1560444885542383937670.46d0cb6c.jpg";